import { render, staticRenderFns } from "./PromoLanguageSwitcher.vue?vue&type=template&id=7a4de96e&scoped=true&"
import script from "./PromoLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./PromoLanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PromoLanguageSwitcher.vue?vue&type=style&index=0&id=7a4de96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4de96e",
  null
  
)

export default component.exports